import { render, staticRenderFns } from "./IMList.vue?vue&type=template&id=6ebcec73&scoped=true&lang=pug"
import script from "./IMList.vue?vue&type=script&lang=js"
export * from "./IMList.vue?vue&type=script&lang=js"
import style0 from "./IMList.vue?vue&type=style&index=0&id=6ebcec73&prod&scoped=true&lang=css"
import style1 from "./IMList.vue?vue&type=style&index=1&id=6ebcec73&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebcec73",
  null
  
)

export default component.exports